import { Injectable } from '@angular/core';
import { ShowEvent } from '../models/show-event.model';

@Injectable({ providedIn: 'root' })
export class ShowArchiveService {
  readonly events: ShowEvent[] = [
    {
      id: 'quizpoker-gaming-2026-02-20',
      title: '50 Fragen zu Gaming',
      format: 'Quizpoker',
      date: '2026-02-20',
      questionCount: 50,
      status: 'Gespielt',
      winner: 'Kira',
      summary: 'Gaming-Abend mit Schätzfragen, Blinds, Tipps und mehreren knappen All-in-Momenten.',
      participants: [
        { name: 'DaniiPlace', role: 'Host', chips: 0, correctAnswers: 0, finalPlace: 0 },
        { name: 'Kira', role: 'Creator', chips: 3240, correctAnswers: 12, finalPlace: 1 },
        { name: 'Mika', role: 'Creator', chips: 1880, correctAnswers: 9, finalPlace: 2 },
        { name: 'Neo', role: 'Spieler', chips: 920, correctAnswers: 7, finalPlace: 3 }
      ],
      questionResults: [
        { round: 1, category: 'Minecraft', question: 'Wie viele Blöcke breit ist eine Minecraft-Welt ungefähr?', answer: '60 Millionen Blöcke', closestPlayer: 'Kira', winner: 'Kira', pot: 450 },
        { round: 2, category: 'Nintendo', question: 'In welchem Jahr erschien die Nintendo Switch?', answer: '2017', closestPlayer: 'Mika', winner: 'Mika', pot: 380 },
        { round: 3, category: 'Speedrunning', question: 'Wie viele Minuten dauerte ein früher bekannter Any%-Run in Super Mario 64 ungefähr?', answer: 'unter 7 Minuten', closestPlayer: 'Kira', winner: 'Kira', pot: 720 }
      ]
    },
    {
      id: 'schaetzduell-internet-2026-03-06',
      title: '30 Fragen zu Internet & Creator',
      format: 'Schätzduell',
      date: '2026-03-06',
      questionCount: 30,
      status: 'Geplant',
      winner: 'Noch offen',
      summary: 'Creator-orientiertes Schätzduell rund um Plattformen, Uploads, Views und Internet-Kultur.',
      participants: [
        { name: 'DaniiPlace', role: 'Host', chips: 0, correctAnswers: 0, finalPlace: 0 }
      ],
      questionResults: []
    },
    {
      id: 'lockout-bingo-tech-2026-03-27',
      title: '25 Challenges zu Technik',
      format: 'Lockout Bingo',
      date: '2026-03-27',
      questionCount: 25,
      status: 'Geplant',
      winner: 'Noch offen',
      summary: 'Lockout-Bingo mit Technik-Challenges, die nach Abschluss für andere Teams gesperrt werden.',
      participants: [
        { name: 'DaniiPlace', role: 'Host', chips: 0, correctAnswers: 0, finalPlace: 0 }
      ],
      questionResults: []
    }
  ];

  getById(id: string): ShowEvent | undefined {
    return this.events.find(event => event.id === id);
  }
}
